export default __webpack_public_path__ + "static/media/screensharing.81889b58.svg";